window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.enrollmentBox = window.locales.am.enrollmentBox || {};window.locales.am.enrollmentBox = {...window.locales.am.enrollmentBox, ...{
    "enrollment": "ምዝገባ",
    "upload_your_id": "መታወቂያዎን ይጫኑ",
    "verify_your_identity": "ማንነትዎን ያረጋግጡ",
    "upload_unofficial_transcripts": "ኦፊሴላዊ ያልሆኑ ግልባጮችዎን ይጫኑ",
    "upload_unofficial_transcript": "ኦፊሴላዊ ያልሆነ ግልባጭዎን ይጫኑ",
    "send_us_your_transcripts": "ኦፊሴላዊ ግልባጮችን ይጠይቁ",
    "upload_english_language_documents": "የእንግሊዝኛ ቋንቋ ብቃት ሰነዶችን ይጫኑ",
    "provide_mailing_address": "የመልዕክት አድራሻዎን ያረጋግጡ",
    "in_review": "(በግምገማ ላይ)",
    "needs_more_information": "(ተጨማሪ መረጃ ያስፈልጋል)",
    "sign_enrollment_agreement": "የምዝገባ ስምምነትዎን ይፈርሙ",
    "sign_tila_disclosure": "የክፍያ እቅድ ይፋ መግለጫዎን ይፈርሙ",
    "complete_student_profile": "የተማሪ መገለጫዎን ይሙሉ",
    "show_completed_steps": "የተጠናቀቁ ደረጃዎችን አሳይ",
    "hide_completed_steps": "የተጠናቀቁ ደረጃዎችን ደብቅ",
    "due_by": "የመጨረሻ ቀን",
    "past_due": "ጊዜያቸው ያለፉ ስራዎች",
    "complete_your": "ይጨርሱ",
    "footer_note": "ስለ {enrollmentFaqLink} የበለጠ ይወቁ። ጥያቄዎች አሉዎት? {registrarLink}ን ያግኙ ወይም {appointmentLink} ይያዙ።",
    "enrollment_requirements": "የምዝገባ መስፈርቶች",
    "appointment": "ቀጠሮ",
    "mobile_heading": "ምዝገባዎን ያጠናቅቁ",
    "mobile_cta_text": "ተጨማሪ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.enrollmentBox = window.locales.ar.enrollmentBox || {};window.locales.ar.enrollmentBox = {...window.locales.ar.enrollmentBox, ...{
    "enrollment": "التسجيل",
    "upload_your_id": "قم بتحميل هويتك",
    "verify_your_identity": "تحقق من هويتك",
    "upload_unofficial_transcripts": "قم بتحميل كشوف الدرجات غير الرسمية",
    "upload_unofficial_transcript": "قم بتحميل كشف الدرجات غير الرسمي",
    "send_us_your_transcripts": "اطلب كشوف الدرجات الرسمية",
    "upload_english_language_documents": "قم بتحميل وثائق إجادة اللغة الإنجليزية",
    "provide_mailing_address": "أكد عنوانك البريدي",
    "in_review": "(قيد المراجعة)",
    "needs_more_information": "(يحتاج إلى مزيد من المعلومات)",
    "sign_enrollment_agreement": "وقع على اتفاقية التسجيل الخاصة بك",
    "sign_tila_disclosure": "وقع على إفصاح خطة الدفع الخاصة بك",
    "complete_student_profile": "أكمل ملف الطالب الخاص بك",
    "show_completed_steps": "إظهار الخطوات المكتملة",
    "hide_completed_steps": "إخفاء الخطوات المكتملة",
    "due_by": "مستحق في",
    "past_due": "المهام المتأخرة",
    "complete_your": "أكمل",
    "footer_note": "تعرف على المزيد حول {enrollmentFaqLink}. أسئلة؟ اتصل بـ {registrarLink} أو حدد {appointmentLink}.",
    "enrollment_requirements": "متطلبات التسجيل",
    "appointment": "موعد",
    "mobile_heading": "أكمل تسجيلك",
    "mobile_cta_text": "المزيد"
}
};window.locales.en = window.locales.en || {};window.locales.en.enrollmentBox = window.locales.en.enrollmentBox || {};window.locales.en.enrollmentBox = {...window.locales.en.enrollmentBox, ...{
    "enrollment": "Enrollment",
    "upload_your_id": "Upload your ID",
    "verify_your_identity": "Verify your identity",
    "upload_unofficial_transcripts": "Upload your unofficial transcripts",
    "upload_unofficial_transcript": "Upload your unofficial transcript",
    "send_us_your_transcripts": "Request official transcripts",
    "upload_english_language_documents": "Upload English Language Proficiency documentation",
    "provide_mailing_address": "Confirm your mailing address",
    "in_review": "(In Review)",
    "needs_more_information": "(Needs More Information)",
    "sign_enrollment_agreement": "Sign your Enrollment Agreement",
    "sign_tila_disclosure": "Sign your Payment Plan Disclosure",
    "complete_student_profile": "Complete your student profile",
    "show_completed_steps": "Show Completed Steps",
    "hide_completed_steps": "Hide Completed Steps",
    "due_by": "Due by",
    "past_due": "Past Due Tasks",
    "complete_your": "Complete Your",
    "footer_note": "Learn more about {enrollmentFaqLink}. Questions? Contact {registrarLink} or schedule an {appointmentLink}.",
    "enrollment_requirements": "enrollment requirements",
    "appointment": "appointment",
    "mobile_heading": "Complete Your Enrollment",
    "mobile_cta_text": "More"
}
};window.locales.es = window.locales.es || {};window.locales.es.enrollmentBox = window.locales.es.enrollmentBox || {};window.locales.es.enrollmentBox = {...window.locales.es.enrollmentBox, ...{
    "enrollment": "Inscripción",
    "upload_your_id": "Carga tu identificación",
    "verify_your_identity": "Verifica tu identidad",
    "upload_unofficial_transcripts": "Carga tus transcripciones no oficiales",
    "upload_unofficial_transcript": "Carga tu transcripción no oficial",
    "send_us_your_transcripts": "Solicita transcripciones oficiales",
    "upload_english_language_documents": "Carga la documentación de dominio del idioma inglés",
    "provide_mailing_address": "Confirma tu dirección postal",
    "in_review": "(En revisión)",
    "needs_more_information": "(Necesita más información)",
    "sign_enrollment_agreement": "Firma tu Acuerdo de inscripción",
    "sign_tila_disclosure": "Firma tu Divulgación del plan de pago",
    "complete_student_profile": "Completa tu perfil de estudiante",
    "show_completed_steps": "Mostrar pasos completados",
    "hide_completed_steps": "Ocultar pasos completados",
    "due_by": "Vence el",
    "past_due": "Tareas vencidas",
    "complete_your": "Completa tu",
    "footer_note": "Obtén más información sobre {enrollmentFaqLink}. ¿Preguntas? Contacta a {registrarLink} o programa una {appointmentLink}.",
    "enrollment_requirements": "requisitos de inscripción",
    "appointment": "cita",
    "mobile_heading": "Completa tu inscripción",
    "mobile_cta_text": "Más"
}
};window.locales.it = window.locales.it || {};window.locales.it.enrollmentBox = window.locales.it.enrollmentBox || {};window.locales.it.enrollmentBox = {...window.locales.it.enrollmentBox, ...{
    "enrollment": "Iscrizione",
    "upload_your_id": "Carica il tuo documento d'identità",
    "verify_your_identity": "Verifica la tua identità",
    "upload_unofficial_transcripts": "Carica le tue trascrizioni non ufficiali",
    "upload_unofficial_transcript": "Carica la tua trascrizione non ufficiale",
    "send_us_your_transcripts": "Richiedi trascrizioni ufficiali",
    "upload_english_language_documents": "Carica la documentazione sulla competenza della lingua inglese",
    "provide_mailing_address": "Conferma il tuo indirizzo postale",
    "in_review": "(In revisione)",
    "needs_more_information": "(Necessita di ulteriori informazioni)",
    "sign_enrollment_agreement": "Firma il tuo Accordo di iscrizione",
    "sign_tila_disclosure": "Firma la tua Informativa sul piano di pagamento",
    "complete_student_profile": "Completa il tuo profilo studente",
    "show_completed_steps": "Mostra passaggi completati",
    "hide_completed_steps": "Nascondi passaggi completati",
    "due_by": "Scadenza",
    "past_due": "Attività scadute",
    "complete_your": "Completa il tuo",
    "footer_note": "Scopri di più su {enrollmentFaqLink}. Domande? Contatta {registrarLink} o prenota un {appointmentLink}.",
    "enrollment_requirements": "requisiti di iscrizione",
    "appointment": "appuntamento",
    "mobile_heading": "Completa la tua iscrizione",
    "mobile_cta_text": "Altro"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.enrollmentBox = window.locales.zh.enrollmentBox || {};window.locales.zh.enrollmentBox = {...window.locales.zh.enrollmentBox, ...{
    "enrollment": "注册",
    "upload_your_id": "上传您的身份证件",
    "verify_your_identity": "验证您的身份",
    "upload_unofficial_transcripts": "上传您的非正式成绩单",
    "upload_unofficial_transcript": "上传您的非正式成绩单",
    "send_us_your_transcripts": "申请正式成绩单",
    "upload_english_language_documents": "上传英语语言能力证明文件",
    "provide_mailing_address": "确认您的邮寄地址",
    "in_review": "(审核中)",
    "needs_more_information": "(需要更多信息)",
    "sign_enrollment_agreement": "签署您的注册协议",
    "sign_tila_disclosure": "签署您的付款计划披露",
    "complete_student_profile": "完善您的学生资料",
    "show_completed_steps": "显示已完成的步骤",
    "hide_completed_steps": "隐藏已完成的步骤",
    "due_by": "截止日期",
    "past_due": "逾期任务",
    "complete_your": "完成您的",
    "footer_note": "了解更多关于 {enrollmentFaqLink} 的信息。有疑问?请联系 {registrarLink} 或预约 {appointmentLink}。",
    "enrollment_requirements": "注册要求",
    "appointment": "预约",
    "mobile_heading": "完成您的注册",
    "mobile_cta_text": "更多"
}
};